/** @typedef textStrings single set: simple array [id, text, x, y, anchorX, anchorY]*/

/** @typedef textStrings for muliple sets: 
 * textStrings: {
 *   remote: [{
 *     id: 'city1',
       text: '<b>formatted text</b> with <br>line breaks',
*     desktop: {
*       x,y,anchorX, anchorY
*     },
*     mobile: {
*       x,y,anchorX, anchorY
*     }, 
*   ...],
*   close: [{
*     desktop: {
*       x,y,anchorX, anchorY
*     },
*     mobile: {
*       x,y,anchorX, anchorY
*     }
*    },
*   ...]
*   }
*/

export const configCases = {
	bakhmut: {
		statistics: {
			total: 19000,
			percent: 0.66,
			moderate: 0.35,
			significant: 0.28,
			severe: 0.03
		},
		connector_line: {
			left: 0.5,
			height: 0.35
		},
		textStrings: {
			remote: [
				{
					id: 'bakhmut35',
					text: '<b>Metal works</b>',
					anchor_x: 'start',
					anchor_y: 'end',
					desktop: {
						x: 275,
						y: 125
					},
					mobile: {
						x: 282,
						y: 120.0
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut36',
					text: '<b>Central</b> and riverbank areas were damaged.',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 150,
						y: 188
					},
					mobile: false,
					hideOnMobile: true,
					is_placemark: false
				},
				{
					id: 'bakhmut37',
					text: "Damaged <b>childrens' hospital</b>",
					anchor_x: 'center',
					anchor_y: 'start',
					desktop: {
						x: 105,
						y: 325
					},
					mobile: {
						x: 112.0,
						y: 438
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut38',
					text: '<b>Residential areas</b> in the east were largely destroyed.',
					anchor_x: 'center',
					anchor_y: 'start',
					desktop: {
						x: 457,
						y: 372
					},
					mobile: {
						x: 449.0,
						y: 453.0
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut39',
					text: 'Bakhmut',
					is_placemark: true,
					is_prominent: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 344,
						y: 175
					},
					mobile: false,
					hideOnMobile: true
				},
				{
					id: 'bakhmut40',
					text: 'Detail below',
					is_italic: true,
					anchor_x: 'start',
					anchor_y: 'end',
					desktop: {
						x: 228,
						y: 230
					},
					mobile: {
						x: 226,
						y: 270
					},
					hideOnMobile: false,
					is_placemark: true
				}
			],
			close: [
				{
					id: 'bakhmut41',
					text: 'Artillery fire left craters in the <b>soccer stadium</b> and destroyed surrounding housing blocks.',
					anchor_x: 'start',
					anchor_y: 'end',
					desktop: {
						x: 210,
						y: 105
					},
					mobile: {
						x: 187.0,
						y: 140
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut42',
					text: 'The <b>cultural center</b> of opera and theater was destroyed.',
					anchor_x: 'center',
					anchor_y: 'start',
					desktop: {
						x: 154,
						y: 275
					},
					mobile: {
						x: 124.0,
						y: 312.0
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut43',
					text: 'District administration',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 240,
						y: 414
					},
					mobile: {
						x: 227.0,
						y: 460.0
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut44',
					text: 'East of the river, entire <b>housing blocks</b> were destroyed in urban warfare.',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 378,
						y: 252
					},
					mobile: {
						x: 358,
						y: 300
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut46',
					text: 'Bakhmut',
					is_placemark: true,
					is_prominent: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 344,
						y: 208
					},
					mobile: {
						x: 319.0,
						y: 230
					},
					hideOnMobile: false
				}
			]
		}
	},
	mariupol: {
		noCloseUp: true,
		statistics: {
			total: 36000,
			percent: 0.36,
			moderate: 0.17,
			significant: 0.14,
			severe: 0.05
		},
		connector_line: {
			left: 0.34,
			height: 0.31
		},
		textStrings: {
			remote: [
				{
					id: 'mariupol1',
					text: '<b>Cemeteries</b> with thousands of new unmarked graves',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 119,
						y: 114
					},
					mobile: {
						x: 120,
						y: 170
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol2',
					text: '<b>10 people</b> died after an attack on a military hospital.',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 400,
						y: 150
					},
					mobile: false,
					hideOnMobile: true,
					is_placemark: false
				},
				{
					id: 'mariupol3',
					text: '<b>Azovstal steel works:</b> last retreat of the Ukrainian forces',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 446,
						y: 346
					},
					mobile: {
						x: 440,
						y: 380
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol4',
					text: 'In the <b>center</b> and the <b>port area</b>, entire neighborhoods were reduced to rubble.',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 258,
						y: 408
					},
					mobile: {
						x: 216,
						y: 475
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol10',
					text: 'Mariupol',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 338,
						y: 232
					},
					mobile: {
						x: 375,
						y: 187
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				},
				{
					id: 'mariupol11',
					text: 'Sea of Azov',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 520,
						y: 442
					},
					mobile: {
						x: 510,
						y: 520
					},
					hideOnMobile: false,
					is_placemark: true,
					is_landscape: true,
					is_maritime: true
				},
				// {
				// 	id: 'mariupol12',
				// 	text: 'detail below',
				// 	is_italic: true,
				// 	anchor_x: 'start',
				// 	anchor_y: 'bottom',
				// 	desktop: {
				// 		x: 127,
				// 		y: 258
				// 	},
				// 	mobile: {
				// 		x: 115,
				// 		y: 330
				// 	},
				// 	hideOnMobile: false,
				// 	is_placemark: true
				// },
				{
					id: 'mariupol13',
					text: 'Center',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 249,
						y: 320
					},
					mobile: {
						x: 198,
						y: 390
					},
					hideOnMobile: false,
					is_placemark: true
				},
				{
					id: 'mariupol14',
					text: 'Port area',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 130,
						y: 415
					},
					mobile: {
						x: 130,
						y: 480
					},
					hideOnMobile: false,
					is_placemark: true
				}
			],
			close: [
				{
					id: 'mariupol6',
					text: '<b>The maternity ward</b> targeted in airstrikes',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 268,
						y: 194
					},
					mobile: {
						x: 440,
						y: 250
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol7',
					text: 'People were hiding in the basements of <b>multi-story buildings</b>. Many houses were destroyed and people died.',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 20,
						y: 318
					},
					mobile: {
						x: 110,
						y: 110
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol8',
					text: 'Likely dozens of civilians died after air targeting of the <b>theater used as a shelter</b>.',
					anchor_x: 'center',
					anchor_y: 'start',
					desktop: {
						x: 476,
						y: 343
					},
					mobile: {
						x: 480,
						y: 400
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol15',
					text: 'Mariupol',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 318,
						y: 269
					},
					mobile: {
						x: 260,
						y: 310
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			]
		}
	},
	sievierodonetsk: {
		statistics: {
			total: 4000,
			percent: 0.36,
			moderate: 0.2,
			significant: 0.13,
			severe: 0.3
		},
		connector_line: {
			left: 0.66,
			height: 0.18
		},
		textStrings: {
			remote: [
				{
					id: 'sievierodonetsk20',
					text: 'The <b>Shchedrishchevo microdistrict</b> was almost completely destroyed.',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 361,
						y: 93
					},
					mobile: {
						x: 96,
						y: 65
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk21',
					text: 'The <b>city hospital</b> was under fire many times.',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 359,
						y: 181
					},
					mobile: {
						x: 370,
						y: 165
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk22',
					text: 'The <b>power plant</b> supplying the town was destroyed.',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 172,
						y: 350
					},
					mobile: {
						x: 170.0,
						y: 470
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk23',
					text: 'Sievierodonetsk',
					is_prominent: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 218,
						y: 183
					},
					mobile: {
						x: 194.0,
						y: 162.0
					},
					hideOnMobile: false,
					is_placemark: true
				},
				{
					id: 'sievierodonetsk24',
					text: 'Detail below',
					is_italic: true,
					anchor_x: 'start',
					anchor_y: 'end',
					desktop: {
						x: 318,
						y: 293
					},
					mobile: {
						x: 305,
						y: 290
					},
					hideOnMobile: false,
					is_placemark: true
				},
				{
					id: 'sievierodonetsk25',
					text: 'Chemical plant',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 157,
						y: 319
					},
					mobile: {
						x: 134.0,
						y: 322.0
					},
					hideOnMobile: false,
					is_placemark: true
				},
				{
					id: 'sievierodonetsk27',
					text: 'to Lysychansk',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 140,
						y: 466
					},
					mobile: {
						x: 100.0,
						y: 571.0
					},
					hideOnMobile: false,
					is_placemark: true
				}
			],
			close: [
				{
					id: 'sievierodonetsk29',
					text: 'The <b>residential areas</b> in the center suffered heavy losses.',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 150,
						y: 128
					},
					mobile: {
						x: 140,
						y: 146.0
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk30',
					text: 'The prestigious <b>Ice Sports Palace</b> was burnt down completely during the fights.',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 150,
						y: 270
					},
					mobile: {
						x: 117.0,
						y: 350
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk31',
					text: '<b>A cathedral</b> was damaged by the attacks.',
					anchor_x: 'end',
					anchor_y: 'end',
					desktop: {
						x: 500,
						y: 240
					},
					mobile: {
						x: 600,
						y: 210
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk32',
					text: 'Sievierodonetsk',
					is_prominent: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 375,
						y: 142
					},
					mobile: {
						x: 293.0,
						y: 211.0
					},
					hideOnMobile: false,
					is_placemark: true
				}
			]
		}
	},
	kherson: {
		noCloseUp: true,
		connector_line: {
			left: 0.5,
			height: 0.35
		},
		textStrings: {
			remote: [
				{
					id: 'kherson49',
					text: 'A <b>maternity ward</b> was shelled.',
					anchor_x: 'end',
					anchor_y: 'end',
					desktop: {
						x: 250,
						y: 220
					},
					mobile: {
						x: 275,
						y: 275
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson50',
					text: 'The <b>ship wharf</b> suffered heavy destruction.',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 154,
						y: 331
					},
					mobile: {
						x: 110,
						y: 380
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson51',
					text: 'Many died under shelling of a <b>central street</b> on Christmas Eve 2022.',
					anchor_x: 'center',
					anchor_y: 'end',
					desktop: {
						x: 360,
						y: 210
					},
					mobile: {
						x: 290,
						y: 200
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson52',
					text: 'A strike on a <b>hospital</b> killed a doctor.',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 385,
						y: 295
					},
					mobile: false,
					hideOnMobile: true,
					is_placemark: false
				},
				{
					id: 'kherson53',
					text: 'Damaged <b>residential buildings</b>',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 450,
						y: 360
					},
					mobile: {
						x: 460,
						y: 410
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson54',
					text: 'Destroyed <b>high school</b>',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 310,
						y: 415
					},
					mobile: {
						x: 270,
						y: 480
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson55',
					text: 'Ship wharf and docks',
					is_placemark: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 200,
						y: 433
					},
					mobile: {
						x: 220,
						y: 500
					},
					hideOnMobile: false
				},
				{
					id: 'kherson56',
					text: 'Kherson',
					is_placemark: true,
					is_prominent: true,
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 364,
						y: 257
					},
					mobile: {
						x: 433,
						y: 240
					},
					hideOnMobile: false
				}
			],
			close: false
		}
	}
}
